import { useQuery } from "@tanstack/react-query";
import { GroupChannel } from "@sendbird/chat/groupChannel";

export function useChannelPriority(channel: GroupChannel) {
  return useQuery({
    queryKey: ["channel-priority", channel?.url],
    queryFn: async () => {
      const priorityModeMeta = channel?.cachedMetaData;

      if ("priority_mode" in priorityModeMeta) {
        return priorityModeMeta?.priority_mode === "true";
      }

      return false;
    },
    enabled: !!channel,
  });
}
